import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-candidate-commented',
  templateUrl: './activity-item-candidate-commented.component.html',
  styleUrls: ['./activity-item-candidate-commented.component.scss']
})
export class ActivityItemCandidateCommentedComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;

  
  @Input()
  language: 'de' | 'en' = 'de';

  // in a candidate's own feed the candidate goes without saying
  @Input()
  context: string = null;

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

}
